import { render, staticRenderFns } from "./FreeWagerGroup.vue?vue&type=template&id=8cb91ea8&scoped=true&"
import script from "./FreeWagerGroup.vue?vue&type=script&lang=js&"
export * from "./FreeWagerGroup.vue?vue&type=script&lang=js&"
import style0 from "./FreeWagerGroup.vue?vue&type=style&index=0&id=8cb91ea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb91ea8",
  null
  
)

export default component.exports